import React from 'react';
import clsx from 'clsx';

import { WorkspaceTab } from './WorkspaceContainer';

export interface WorkspaceTabsProps {
  activeTab: WorkspaceTab;
  setActiveTab: (tab: WorkspaceTab) => void;
  isReportsEnabled?: boolean;
  tabCounts?: { all?: number; todos?: number; review?: number };
}

const tabList: { key: WorkspaceTab; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'todos', label: 'To Dos' },
  { key: 'review', label: 'For Review / Approval' },
];

const WorkspaceTabs: React.FC<WorkspaceTabsProps> = ({
  activeTab,
  setActiveTab,
  tabCounts = {},
}) => {
  return (
    <div
      className={clsx(
        'tw-flex',
        'tw-flex-wrap',
        'tw-w-full',
        'tw-overflow-x-auto',
        'tw-mb-6',
        'tw-gap-2'
      )}
    >
      {tabList.map((tab) => (
        <button
          key={tab.key}
          className={clsx(
            'tw-px-4',
            'tw-py-2',
            'tw-rounded-full',
            'tw-font-medium',
            'tw-transition',
            'tw-duration-150',
            'tw-ease-in-out',
            activeTab === tab.key
              ? 'tw-bg-cfo-blue-600 tw-text-white tw-shadow'
              : 'tw-bg-gray-100 tw-text-black',
            'tw-whitespace-nowrap'
          )}
          onClick={() => setActiveTab(tab.key)}
        >
          {tab.label}
          {typeof tabCounts[tab.key] === 'number' && (
            <span style={{ marginLeft: 6 }}>({tabCounts[tab.key]})</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default WorkspaceTabs;
